import React from "react";
import { motion } from "framer-motion/dist/framer-motion";

import {
  divVariants,
  staticBounceVariants,
  bounce_right_to_left_variants
} from "shared/components/animations";

const TWJoining = ({ users, isOver = false }) => {
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="tw-joining"
    >
      <motion.h2 variants={bounce_right_to_left_variants} className="top-text">
        {isOver ? "Game Over" : "Waiting to Start"}
      </motion.h2>
      <div className="tw-players">
        <div className="tw-players-flex">
          {users?.map((item, index) => {
            const dynamicIndex = (index % 6) + 1;
            return (
              <motion.div
                key={index}
                variants={staticBounceVariants}
                className="tw-players-card"
              >
                <div className={`player-circle player-circle-${dynamicIndex}`}>
                  <img src={item?.profile_image} className="img-fluid" alt="" />
                </div>
                <h4 className="name">{item?.display_name}</h4>
              </motion.div>
            );
          })}
        </div>
      </div>
    </motion.div>
  );
};

export default TWJoining;
